import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { Button, Divider, Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { SubscriptionStatus } from "../../../../OrderFlow/utils/orderFlowUtils";
import { useCompany } from "../../../../Shared/components/CompanyProvider/CompanyProvider";
import useToast from "../../../../hooks/useToast";
import AlertDialog from "../../../AlertDialog";
import { update_subscription_status } from "../../../constants";
import SubscriptionContext from "../../../store/subscriptionContext";
import { UpdateOrderDeliveryModal } from "../../../useUpdateOrderDeliveryModal/NonContextModalComponent/UpdateOrderDeliveryModal";
import { UpdateOrderDeliveryPickupModalContext } from "../../../useUpdateOrderDeliveryModal/deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { cancelSubscription, getSubscriptionOrders, pauseSubscription, resumeSubscription, } from "../../../utils/requests";
import { CancelSubscriptionModal } from "../../CancelSubscriptionModal";
import { EditSubscriptionModal } from "../../EditSubscriptionModal";
import { PauseSubscriptionModal } from "../../PauseSubscriptionModal";
import { groupOrders } from "../../ToggleableOrdersList/ToggleableOrdersList-utils";
import { ToggleableOrdersListModal } from "../../ToggleableOrdersListModal";
import { SubscriptionsTexts } from "../../subscriptionsUtils/constsAndEnums";
export const Sub_ActionsButtons = ({ showEditButton, subUpdatedEffectiveChangeText, contactUsToMakeChangesText, showContactUsToMakeChanges, showPauseButton, showResumeButton, currentOrderId, currentOrderInfo, currentOrderNumber, currentOrderStatus, subscriptionInfo, showCancelInfoModal, hideUnsubscribeButton, subscriptionIsPausedOrActive, initTabProps, programId, subscriptionStatus, flowSku, disableUpdateDeliveryFeature, }) => {
    var _a;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { subscriptionsStore, dispatch, refetchSubscriptions, updateFunction } = useContext(SubscriptionContext);
    const toast = useToast();
    const history = useHistory();
    const { tokenMap } = useCompany();
    const [isPauseLoading, setIsPauseLoading] = useState(false);
    const [isCancelLoading, setIsCancelLoading] = useState(false);
    const [isPauseModalOpen, setIsPauseModalOpen] = useState(false);
    const [isCancelOrdersModalOpen, setIsCancelOrdersModalOpen] = useState(false);
    const [cancelOrdersModalCallback, setCancelOrdersModalCallback] = useState(() => { });
    const [cancelOrdersModalTitle, setCancelOrdersModalTitle] = useState(null);
    const [cancelOrdersModalBody, setCancelOrdersModalBody] = useState(null);
    const [orderGroups, setOrderGroups] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isCancelSubModalOpen, setIsCancelSubModalOpen] = useState(false);
    const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogText, setDialogText] = useState(null);
    const [shouldRefetch, setShouldRefetch] = useState(false);
    const { setIsModalOpen: setContextIsModalOpen } = useContext(UpdateOrderDeliveryPickupModalContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openCloseModal = (open) => {
        setIsModalOpen(open);
        setContextIsModalOpen(open);
    };
    const handleGetSubscriptionOrders = (tokenMap) => (res) => {
        const [ordersPastCutoff, upcomingOrders] = groupOrders(res.data.orders, tokenMap);
        setOrderGroups([ordersPastCutoff, upcomingOrders]);
        setIsCancelSubModalOpen(false);
        setIsPauseModalOpen(false);
        setIsPauseLoading(false);
        setIsCancelLoading(false);
        setIsCancelOrdersModalOpen(true);
    };
    const handleOpenAlertDialog = () => {
        if (shouldRefetch && isAlertDialogOpen) {
            history.push("/temp");
            history.goBack();
        }
        setIsAlertDialogOpen(!isAlertDialogOpen);
    };
    const handleOpenPauseModal = () => {
        setIsPauseModalOpen(!isPauseModalOpen);
    };
    const handleOpenEditModal = () => {
        setIsEditModalOpen(!isEditModalOpen);
    };
    const handleOpenCancelModal = () => {
        setIsCancelSubModalOpen(!isCancelSubModalOpen);
    };
    const handlePauseSubscription = () => {
        if (subscriptionInfo.PauseAllowCancelOrders) {
            setIsPauseLoading(true);
            setCancelOrdersModalTitle(subscriptionInfo.PauseCancelOrdersModalTitle);
            setCancelOrdersModalBody(subscriptionInfo.PauseCancelOrdersModalBody);
            setCancelOrdersModalCallback(() => pauseSubscriptionCallback);
            getSubscriptionOrders(subscriptionInfo.subscriptionLinkId, handleGetSubscriptionOrders(tokenMap), (e) => {
                setIsPauseLoading(false);
                setIsPauseModalOpen(false);
                toast.push(SubscriptionsTexts.PAUSE_PROBLEM, { variant: "error" });
            });
        }
        else {
            pauseSubscriptionCallback();
        }
    };
    const pauseSubscriptionCallback = (orderIdsToCancel = null) => {
        const onSuccess = (res) => {
            setIsPauseLoading(false);
            setIsPauseModalOpen(false);
            setIsCancelOrdersModalOpen(false);
            if (!res.data.success) {
                // PAUSE SUBSCRIPTION ERROR TOAST
                toast.push(SubscriptionsTexts.PAUSE_PROBLEM, { variant: "error" });
            }
            let index = subscriptionsStore.subscriptions.findIndex((sub) => sub.subscriptionInfo.orderId === currentOrderId);
            dispatch({
                type: update_subscription_status,
                payload: { index, status: SubscriptionStatus.Paused },
            });
            // PAUSE SUBSCRIPTION SUCCESS TOAST
            toast.push(SubscriptionsTexts.PAUSED, { variant: "success" });
        };
        const onError = (e) => {
            setIsPauseModalOpen(false);
            setIsCancelOrdersModalOpen(false);
            setIsPauseLoading(false);
            // PAUSE SUBSCRIPTION ERROR TOAST
            toast.push(SubscriptionsTexts.PAUSE_PROBLEM, { variant: "error" });
        };
        setIsPauseLoading(true);
        pauseSubscription(currentOrderId, orderIdsToCancel, onSuccess, onError);
    };
    const handleResumeSubscription = () => {
        const onSuccess = (res) => {
            setIsPauseLoading(false);
            if (!res.data.success) {
                // RESUME SUBSCRIPTION ERROR TOAST
                toast.push(SubscriptionsTexts.PROBLEM_RESUMING, { variant: "error" });
            }
            let index = subscriptionsStore.subscriptions.findIndex((sub) => sub.subscriptionInfo.orderId === currentOrderId);
            dispatch({
                type: update_subscription_status,
                payload: { index, status: SubscriptionStatus.Active },
            });
            setShouldRefetch(true);
            // RESUME SUBSCRIPTION SUCCESS TOAST
            toast.push(subscriptionInfo.ResumeSubscriptionModalText, { variant: "success" });
        };
        const onError = (e) => {
            setIsPauseLoading(false);
            // RESUME SUBSCRIPTION ERROR TOAST
            toast.push(SubscriptionsTexts.PROBLEM_RESUMING, { variant: "error" });
        };
        setIsPauseLoading(true);
        resumeSubscription(currentOrderId, onSuccess, onError);
    };
    const handleCancelSubscription = (reasons) => {
        if (subscriptionInfo.CancelAllowCancelOrders) {
            setIsCancelLoading(true);
            setCancelOrdersModalTitle(subscriptionInfo.CancelCancelOrdersModalTitle);
            setCancelOrdersModalBody(subscriptionInfo.CancelCancelOrdersModalBody);
            setCancelOrdersModalCallback(() => cancelSubscriptionCallbackHook(reasons));
            getSubscriptionOrders(subscriptionInfo.subscriptionLinkId, handleGetSubscriptionOrders(tokenMap), () => {
                setIsCancelLoading(false);
                setIsCancelSubModalOpen(false);
                toast.push(SubscriptionsTexts.PROBLEM_CANCELLING, { variant: "error" });
            });
        }
        else {
            cancelSubscriptionCallback(reasons);
        }
    };
    const cancelSubscriptionCallbackHook = (reasons) => (orderIdsToCancel) => {
        cancelSubscriptionCallback(reasons, orderIdsToCancel);
    };
    const cancelSubscriptionCallback = (reasons, orderIdsToCancel = null) => {
        const onSuccess = (res) => {
            setIsCancelLoading(false);
            setIsCancelSubModalOpen(false);
            setIsCancelOrdersModalOpen(false);
            if (!res.data.success) {
                // CANCEL SUBSCRIPTION ERROR TOAST
                toast.push(SubscriptionsTexts.PROBLEM_CANCELLING, { variant: "error" });
            }
            let index = subscriptionsStore.subscriptions.findIndex((sub) => sub.subscriptionInfo.orderId === currentOrderId);
            dispatch({
                type: update_subscription_status,
                payload: { index, status: SubscriptionStatus.Cancelled },
            });
            // CANCEL SUBSCRIPTION SUCCESS TOAST
            toast.push(SubscriptionsTexts.CANCELLED, { variant: "success" });
        };
        const onError = (e) => {
            setIsCancelLoading(false);
            setIsCancelSubModalOpen(false);
            setIsCancelOrdersModalOpen(false);
            // CANCEL SUBSCRIPTION ERROR TOAST
            toast.push(SubscriptionsTexts.PROBLEM_CANCELLING, { variant: "error" });
        };
        setIsCancelLoading(true);
        cancelSubscription(currentOrderId, reasons, orderIdsToCancel, onSuccess, onError);
    };
    const handleCancelOrders = (orders) => {
        const orderIdsToCancel = orders.map((o) => o.OrderId);
        cancelOrdersModalCallback(orderIdsToCancel);
    };
    // TODO! Create a single accordion button container to be shared between orders and subs & etc.
    return (_jsxs(_Fragment, { children: [_jsx(Grid, Object.assign({ item: true, xx: 12, sm: 3 }, { children: _jsxs(Stack, Object.assign({ display: "flex", flexDirection: "column", flexWrap: "nowrap", justifyContent: "center", alignItems: "center", minWidth: isMobile ? "100%" : theme.spacing(20.5), rowGap: theme.spacing(1) }, { children: [subscriptionStatus !== SubscriptionStatus.Cancelled && (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, color: "primary", variant: "contained", onClick: () => openCloseModal(true) }, { children: SubscriptionsTexts.UPDATE_DELIVERY }))), showEditButton && (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "primary", onClick: handleOpenEditModal }, { children: SubscriptionsTexts.EDIT_SUB }))), showPauseButton && (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "primary", onClick: handleOpenPauseModal }, { children: SubscriptionsTexts.PAUSE_SUB }))), showResumeButton && (_jsx(LoadingButton, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "primary", disabled: isPauseLoading, loading: isPauseLoading, onClick: handleResumeSubscription }, { children: SubscriptionsTexts.RESUME_SUB }))), subscriptionIsPausedOrActive && !hideUnsubscribeButton && (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "text", color: "primary", onClick: () => {
                                if (showCancelInfoModal) {
                                    setDialogTitle(subscriptionInfo.CancelSubscriptionInfoModalTitle);
                                    setDialogText(subscriptionInfo.CancelSubscriptionInfoModalText);
                                    handleOpenAlertDialog();
                                }
                                else {
                                    handleOpenCancelModal();
                                }
                            } }, { children: SubscriptionsTexts.UNSUBSCRIBE }))), showContactUsToMakeChanges && _jsx(Typography, { children: contactUsToMakeChangesText }), subscriptionStatus !== SubscriptionStatus.Cancelled && (_jsx(Typography, { children: subUpdatedEffectiveChangeText })), isMobile && _jsx(Divider, { flexItem: true })] })) })), isEditModalOpen && (_jsx(EditSubscriptionModal, { isOpen: isEditModalOpen, onClose: handleOpenEditModal, currentOrderId: currentOrderId, sku: subscriptionInfo.sku, dateChangesTakeEffect: subscriptionInfo.dateChangesTakeEffect, subscriptionLinkId: subscriptionInfo.subscriptionLinkId, startDate: subscriptionInfo.startDate, subscriptionPeriod: currentOrderInfo.subscription_period })), isPauseModalOpen && (_jsx(PauseSubscriptionModal, { isOpen: isPauseModalOpen, onClose: handleOpenPauseModal, handlePauseSubscription: handlePauseSubscription, isPauseLoading: isPauseLoading, pauseButtonText: subscriptionInfo.PauseSubscriptionButtonText, keepButtonText: subscriptionInfo.KeepSubscriptionButtonText, title: subscriptionInfo.PauseSubscriptionModalTitle, text: subscriptionInfo.PauseSubscriptionModalText })), isCancelOrdersModalOpen ? (_jsx(ToggleableOrdersListModal, { title: cancelOrdersModalTitle, body: cancelOrdersModalBody, isOpen: isCancelOrdersModalOpen, isLoading: isPauseLoading || isCancelLoading, orderGroups: orderGroups, onClose: () => setIsCancelOrdersModalOpen(false), onConfirm: handleCancelOrders })) : null, isCancelSubModalOpen && (_jsx(CancelSubscriptionModal, { isOpen: isCancelSubModalOpen, onClose: handleOpenCancelModal, handlePauseSubscription: handlePauseSubscription, handleCancelSubscription: handleCancelSubscription, isPauseLoading: isPauseLoading, isCancelLoading: isCancelLoading, subscriptionStatus: subscriptionInfo.subscriptionStatus, title: subscriptionInfo.CancelSubscriptionModalTitle, text: subscriptionInfo.CancelSubscriptionModalText, cancelButtonText: subscriptionInfo.CancelSubscriptionButtonText, pauseButtonText: subscriptionInfo.PauseSubscriptionButtonText, keepButtonText: subscriptionInfo.KeepSubscriptionButtonText, usesPausedSubscriptions: subscriptionInfo.UsesPausedSubscriptions })), 
            // * This is the modal that will be shown when the user clicks on the "Update Delivery" button.
            isModalOpen && (_jsx(UpdateOrderDeliveryModal, { currentOrderId: currentOrderId, currentOrderInfo: currentOrderInfo, currentOrderNumber: currentOrderNumber, currentOrderStatus: currentOrderStatus, flowSku: flowSku, initTabProps: initTabProps, programId: programId, refetchOrders: refetchSubscriptions, setShowModal: openCloseModal, showModal: isModalOpen, subscriptionLinkId: (_a = subscriptionInfo.subscriptionLinkId) !== null && _a !== void 0 ? _a : undefined, updateFunction: updateFunction })), 
            // By conditionally displaying this alert dialog, we prevent it from being rendered on page load.
            isAlertDialogOpen && (_jsx(AlertDialog, { title: dialogTitle, text: dialogText, isOpen: isAlertDialogOpen, onClose: handleOpenAlertDialog }))] }));
};
